import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';

import qs from 'querystring';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
    successInRequest,
    failedRequest,
    successRemove,
    successRequest,
    stopLoading,
} from './actions';




export function* requestData({ payload }) {
    try {

        const dataState = yield select(state => state.rateio)

        const { params } = payload;

        if (params.wherefield && isEmpty(dataState.params)) {
            const response = yield call(api.get, 'rateio/detalhe', {
                params,
                paramsSerializer: (param) => qs.stringify(param),
            });

            const { items, page, pageSize, totalCount, totalPages } = response.data;

            yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
        } else if (dataState.params) {
            let params = {
                ...dataState.params,
                wherefield: [...dataState.params.wherefield],
                valuewherefield: [...dataState.params.valuewherefield],
                typewherefield: [...dataState.params.typewherefield]
            }

            if (!isEmpty(payload.params.wherefield)) {
                params.wherefield = [...params.wherefield, ...payload.params.wherefield]
                params.valuewherefield = [...params.valuewherefield, ...payload.params.valuewherefield]
                params.typewherefield = [...params.typewherefield, ...payload.params.typewherefield]
            }

            const response = yield call(api.get, 'rateio/detalhe', {
                params,
                paramsSerializer: (param) => qs.stringify(param),
            });

            const { items, page, pageSize, totalCount, totalPages } = response.data;

            yield put(successInRequest(items, page, pageSize, totalCount, totalPages));

        } else {
            stopLoading({ loading: false })
        }

    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export function* deleteData({ payload }) {
    try {
        const { id, params } = payload;

        yield call(api.delete, `orgaos/${id}`);
        yield put(successRemove({ ...params, pesquisalista: true }));

        toast.success(t('s.geral.sucessoexclusao'));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export function* store({ payload }) {
    try {
        const { data, params } = payload;

        yield call(api.post, 'orgaos', data);
        yield put(successRemove({ ...params, pesquisalista: true }));

        toast.success(t('s.geral.sucessoinclusao'));
        history.push('/orgaos');
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export function* find({ payload }) {
    try {
        const { id } = payload;

        const { data } = yield call(api.get, `orgaos/${id}`);
        yield put(successRequest(data));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export function* update({ payload }) {
    try {
        const { data, params } = payload;

        yield call(api.put, 'orgaos', data);
        yield put(successRemove({ ...params, pesquisalista: true }));

        toast.success(t('s.geral.sucessoalteracao'));
        history.push('/orgaos');
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export function* applyedFilters({ payload }) {
    try {
        const { params } = payload;
        const response = yield call(api.get, 'rateio/detalhe', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        const { items, page, pageSize, totalCount, totalPages } = response.data;

        yield put(successInRequest(items, page, pageSize, totalCount, totalPages));


    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export default all([
    takeLatest('@rateio/DATA_IN_REQUEST', requestData),
    takeLatest('@rateio/DELETE_DATA', deleteData),
    takeLatest('@rateio/SUCCESS_REMOVE', requestData),
    takeLatest('@rateio/STORE_DATA', store),
    takeLatest('@rateio/FIND_DATA', find),
    takeLatest('@rateio/UPDATE_DATA', update),
    takeLatest('@rateio/RECORD_FILTERING', applyedFilters),
]);
